import type React from 'react';
import SvgIcon from './SvgIcon';

const ChartBar: React.FC = () => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g id="ChartBar">
      <path d="M5.5 19H3.5V6H5.5V19Z" fill="currentColor" />
      <path d="M10.5 19H8.5V2H10.5V19Z" fill="currentColor" />
      <path d="M15.5 19H13.5V9H15.5V19Z" fill="currentColor" />
      <path d="M20.5 19H18.5V7H20.5V19Z" fill="currentColor" />
    </g>
  </SvgIcon>
);

export default ChartBar;
